import React from "react";
import { Route, Routes } from "react-router-dom";
import FuturePlan from "../Components/Quetionary/InitialKickoff/FuturePlan/FuturePlan";
import Question from "../Components/Quetionary/InitialKickoff/question";
import Company from "../Components/Quetionary/InitialKickoff/CompanyInformation";
import Sustainability from "../Components/Quetionary/InitialKickoff/Sustainability";
import MaterialTopics from "../Components/Quetionary/InitialKickoff/MaterialTopics/MaterialTopics";
// social routes
import DevelopmentAndIncusion from "../Components/Quetionary/Social/Diversity";
import Employeedevelopment from "../Components/Quetionary/Social/EmployeeDevelopment";
import Community from "../Components/Quetionary/Social/Community";
import HumanRight from "../Components/Quetionary/Social/HumanRight";
import CustomerRelation from "../Components/Quetionary/Social/CustomerRelation";
import SupplyChain from "../Components/Quetionary/Social/SupplyChain";

// governance routes
import BoardComposition from "../Components/Quetionary/Governance/BoardComposition";
import ExclutiveCompensation from "../Components/Quetionary/Governance/ExcutiveCompensation";
import Stakeholder from "../Components/Quetionary/Governance/Stakeholder";
import Ethics from "../Components/Quetionary/Governance/EthicsCompliance";
import Cybersecurity from "../Components/Quetionary/Governance/Cybersecurity";
import RiskManagement from "../Components/Quetionary/Governance/RiskMangement";

// Environment routes
import WaterManagement from "../Components/Quetionary/EnvironmentTopics/WaterManagement";
import EnergyManagement from "../Components/Quetionary/EnvironmentTopics/EnergyManagement";
import Pollution from "../Components/Quetionary/EnvironmentTopics/Pollution";
import WasteManagement from "../Components/Quetionary/EnvironmentTopics/WasteManagement";
import Biodiversity from "../Components/Quetionary/EnvironmentTopics/Biodiversity";
import SustainableSourcing from "../Components/Quetionary/EnvironmentTopics/SustainableSourcing";
import GHGEmissions from "../Components/Quetionary/EnvironmentTopics/GHGEmissions";
import PreviewDetails from "../Components/Quetionary/Review/PreviewDetails";
import ViewDetails from "../Components/Quetionary/Review/ViewDetails";
import ESGBaseline from "../Components/Quetionary/InitialKickoff/ESGBaseline";

export const InitialQuestionareRoutes = [
  { path: "/company-information", element: <Company /> },
  { path: "/sustainability", element: <Sustainability /> },
  { path: "/challenges-concerns", element: <Question /> },
  { path: "/future-plans", element: <FuturePlan /> },
  { path: "/material-topics", element: <MaterialTopics /> },
  { path: "/esg-baseline", element: <ESGBaseline /> },
  {
    path: "/environment/energy-management",
    element: <EnergyManagement />,
  },
  { path: "/environment/ghg-emissions", element: <GHGEmissions /> },
  {
    path: "/environment/water-management",
    element: <WaterManagement />,
  },
  {
    path: "/environment/waste-management",
    element: <WasteManagement />,
  },
  { path: "/environment/biodiversity", element: <Biodiversity /> },
  { path: "/environment/pollution", element: <Pollution /> },
  {
    path: "/environment/sustainable-sourcing",
    element: <SustainableSourcing />,
  },
  {
    path: "/social/employee-development",
    element: <Employeedevelopment />,
  },
  { path: "/social/diversity", element: <DevelopmentAndIncusion /> },
  { path: "/social/community", element: <Community /> },
  { path: "/social/human-right", element: <HumanRight /> },
  { path: "/social/customer-relation", element: <CustomerRelation /> },
  { path: "/social/supply-chain", element: <SupplyChain /> },

  {
    path: "/governance/board-composition",
    element: <BoardComposition />,
  },
  {
    path: "/governance/executive-compensation",
    element: <ExclutiveCompensation />,
  },
  { path: "/governance/ethics", element: <Ethics /> },
  { path: "/governance/risk-management", element: <RiskManagement /> },
  { path: "/governance/stakeholder", element: <Stakeholder /> },
  { path: "/governance/cybersecurity", element: <Cybersecurity /> },
  { path: "/preview", element: <PreviewDetails /> },
  { path: "/questionaire", element: <ViewDetails /> },
];
